/**
* @Description 文件功能说明：车辆组件
* @Author
* @Time 2021/6/4
**/
<template>
    <div class="view-tree-table">
    	<!-- router-title-box start -->
		<div class="router-title-box" >
			<div class="router-title-item">
				<a href="javascript:void(0);" class="router-title-back cursor-pointer" @click="closeRouter" title="返回首页"></a>
				<div class="router-title-tit">
					<span style="position: absolute;">&gt;&ensp;信息采集&ensp;&gt;&ensp;车辆信息采集</span>
				</div>
			</div>
		</div>
		<!-- router-title-box end -->
        <section style="height: 100%;overflow: auto;" v-resize="elFormResize">
        <CarGroupTree :carGroups="carGroups" :showBoxFlag="showTreeBoxFlag" @toggleBox="toggleTreeBox" @setSelectVal="setSelectVal" @setTotal="setTotal" @flushGroup="flushGroup"/>
        <CarTable :carGroups="carGroups" :showBoxFlag="showTreeBoxFlag" ref="carTable"/>
        </section>
    </div>
</template>

<script>
import GlobalFun from '@/global/global-function'
import CarGroupTree from "@/components_pages/Car/CarGroupTree";
import CarTable from "@/components_pages/Car/CarTable"
import ApiCar from "@/request/api-car";

export default {
    /*
     * 组件名
     */
    name: "User",
    /**
     * 引用组件
     * */
    components: {
        CarGroupTree,
        CarTable
    },
    /**
     * 数据定义
     * */
    data(){
        return {
            // mini max tree box
            showTreeBoxFlag: true,
            carGroups: []
        }
    },
    /**
     * 方法定义
     */
    methods:{
    	/**
         * @Des 关闭路由
         * @Auth
         * @Date
         */
        closeRouter () {
          // 跳转到 首页
          this.$router.replace({path: this.$store.state.homePage}, ()=>{}, ()=>{});
        },// closeRouter
    	
        // 查询用户组
        searchCarGroup() {
            this.$request.postJsonRequest(ApiCar.searchCarGroupApi,{
                // projectId: this.$store.state.currentProjectId
            }).then(result => {
                this.carGroups = [];
                if(result.code == 0){
                    this.carGroups = GlobalFun.dataToTree(Object.assign([], result.data), {
                        id: 'id',
                        pid: 'parentId',
                        children: 'children',
                        label: 'name'
                    });
                }
            }).catch(error => {
                console.error('查询车辆组异常', ApiCar.searchCarGroupApi, error);
            })
        },
        // 设置选中的值
        setSelectVal(val){
            if(val){
                this.$refs['carTable'].setSelectVal(val);
            }else{
                this.$refs['carTable'].setSelectVal();
            }
        },
        // 切换 tree box 状态
        toggleTreeBox(val) {
            this.showTreeBoxFlag = val;
        },
        flushGroup(groupId, groupName){
            this.searchCarGroup();
            if(groupId != '' && groupName != ''){
                this.setSelectVal({
                    id: groupId,
                    label: groupName
                })
            }
        },
        setTotal(){
            this.$refs.carTable.searchCars();
        },
        /**
         * @Des dom 尺寸更改
         * @Auth
         * @Date 2021/10/8
         */
        elFormResize(data) {
            // 清除定时器
            if (!this.$checkEmpty(this.timer_checkDataInt)) {
                // 清除定时器
                clearInterval(this.timer_checkDataInt);
            }

            if (!this.$checkEmpty(this.overview)) {
                // 延迟执行
                this.$nextTick(() => {
                    // 初始化 charts
                    // this.initCharts();
                });
            } else {
                // 定时器
                this.timer_checkDataInt = setInterval(() => {
                    if (!this.$checkEmpty(this.overview)) {
                        // 清除定时器
                        clearInterval(this.timer_checkDataInt);
                        // 延迟执行
                        this.$nextTick(() => {
                            // 初始化 charts
                            // this.initCharts();
                        });
                    }
                }, 200);
            }
        },

    },
    /**
     * 初始化加载
     */
    mounted() {
        // 查询用户组
        this.searchCarGroup();
    },
}

</script>

/* CSS */
<style lang="scss" scoped>
	
</style>



// WEBPACK FOOTER //
// src/views/system-manager/car/Car.vue